import React from 'react'
import ConsentGate from './ConsentGate'

interface MicrosoftFormProps {
  responseUrl: string
  className?: string
}

const MicrosoftForm: React.FC<MicrosoftFormProps> = ({
  responseUrl,
  className = ''
}) => {
  return (
    <ConsentGate
      type="microsoft"
      serviceName="Microsoft Forms"
      controllerName="Microsoft"
      description="Microsoft Forms uses cookies for authentication, form functionality, and telemetry. Microsoft may collect data about your interaction with the form for analytics and service improvement."
      className={className}
    >
      <iframe
          width="100%"
          height="640px"
          src={`${responseUrl}&embed=true`}
          frameBorder="0"
          style={{border: 'none', maxWidth: '100%', maxHeight: '100vh', borderRadius: '8px'}}
          allowFullScreen={true}
      ></iframe>
    </ConsentGate>
  )
}

export default MicrosoftForm